// extracted by mini-css-extract-plugin
module.exports = {"Loading":"PreloadImage_Loading__2oX0u","Error":"PreloadImage_Error__38U7g"};